import { http } from "services";

export const Enums = (enumName) =>
  http.request.get(`/v1/gov-function/open-enums/${enumName}`);
